export const GET_TYPE_DOCUMENTS_PROVIDER = "GET_TYPE_DOCUMENTS_PROVIDER"
export const GET_TYPE_DOCUMENTS_PROVIDER_SUCCESS = "GET_TYPE_DOCUMENTS_PROVIDER_SUCCESS"
export const GET_TYPE_DOCUMENTS_PROVIDER_API_ERROR = "GET_TYPE_DOCUMENTS_PROVIDER_API_ERROR"

export const GET_TYPE_DOCUMENTS_PROVIDER_ERROR = 'GET_TYPE_DOCUMENTS_PROVIDER_API_ERROR';